import { useEffect, useState, useSyncExternalStore } from "react";
import { useLocation } from "react-router";
import { useIch } from "../../api/abfragen";
import { hinweisBeobachten, hinweisOffen } from "../../api/nutzungHinweis";
import { useToastSichtbar } from "../../design/toastKontext";
import { RueckmeldungBlatt } from "../RueckmeldungBlatt";
import { begruessungGeschlossen, begruesst, begruesstMerken } from "./begruessung";

/** So oft schaut die Begrüßung nach, ob ein anderes Blatt noch steht. */
const WARTEN_MS = 250;

/** W82 Beta-W (D-658, F2 = A): die Beta-Begrüßung im Web, ohne Video und ohne TestFlight. Einmal je Konto und Gerät, nur bei
 *  `ich.beta`, erst nach der Einführung (`ich.eingefuehrt`), nicht auf `/willkommen`, nicht neben dem offenen Hinweis zur
 *  Nutzungsstatistik (`nutzung_hinweis_offen` und dessen Blatt), nicht über einem anderen Blatt oder einer Meldung. Gemerkt
 *  wird beim Öffnen (so zählen „Verstanden“ und jedes Schließen, auch Neuladen mit offenem Blatt). */
export function BetaBegruessung() {
  const { data: ich } = useIch();
  const ort = useLocation();
  const nutzer = ich?.nutzer?.id;
  const nutzungOffen = useSyncExternalStore(hinweisBeobachten, hinweisOffen, () => false);
  const toastSichtbar = useToastSichtbar();
  const [offen, setOffen] = useState(false);
  const faellig =
    Boolean(nutzer && ich?.beta === true && ich.eingefuehrt !== false && !ich.nutzer?.nutzung_hinweis_offen) &&
    !nutzungOffen &&
    !toastSichtbar &&
    ort.pathname !== "/willkommen";
  // erst nach dem ersten Bild der Seite und erst, wenn kein anderes Blatt mehr steht (auch keins, das gerade ausblendet, etwa
  // der Hinweis zur Nutzungsstatistik nach „Wahl speichern“); der Merker im Takt (StrictMode hängt den Effekt einmal probeweise
  // aus, Memory `strictmode-start-effekt`)
  useEffect(() => {
    if (!faellig || !nutzer || offen || begruesst().includes(nutzer)) return;
    let takt = 0;
    const versuchen = () => {
      // W82 Web-5h-N2 a9 (H6, Sonde in w82w5n2a-beta): auch nicht über einem laufenden Rundgang „Zeig sie mir“ (Blase unterwegs
      // der Geist-Ebene); hielt eine Meldung sie auf und startete man den Rundgang, fiel sie sonst mitten hinein
      if (document.querySelector('[role="dialog"], .unterwegs-halter')) {
        takt = window.setTimeout(versuchen, WARTEN_MS);
        return;
      }
      begruesstMerken(nutzer);
      setOffen(true);
    };
    takt = window.setTimeout(versuchen, 0);
    return () => clearTimeout(takt);
  }, [faellig, nutzer, offen]);
  // W82 Beta-W2 (D-704): erst danach beginnt der Auftritt der Startseite (Posteingang.tsx)
  const schliessen = () => {
    setOffen(false);
    begruessungGeschlossen();
  };
  return <RueckmeldungBlatt offen={offen} modus="begruessung" onSchliessen={schliessen} />;
}
